module.exports = __webpack_public_path__ + "static/media/platoon-one-films-logo.aa63097d.png";